module.exports = __webpack_public_path__ + "img/prt00001as.prt.bbecde23.jpg";